import { dateFormatter as NewDateFormatter, DateFormatTypes as NewDateFormatterType } from '../../../util/util'

export const noExpiryString = 'Default Expiry (90 Days)'

export const stateConstForEditLink = (data: any) => {
  return [
    { Amount: data?.amountField },
    { 'Partial Payment': data?.partialPayment === true ? 'Enabled' : 'Disabled' },
    { 'Payment For': data?.paymentForField },
    { 'Mobile Number': data?.mobileNumber },
    { Email: data?.email },
    {
      'Expires On':
        data?.expiry === false
          ? NewDateFormatter(data?.timer, NewDateFormatterType.DD_MMM_YYYY_HH_MM_AMPM)
          : noExpiryString,
    },
    { 'Invoice No': data?.invoice },
    { timer: data?.timer ?? '' },
  ]
}

export const getInitialValues = (data: any) => {
  return {
    amountField: data?.amount?.replace('₹', '')?.trim() ?? data?.amountField,
    paymentForField: data?.description ?? data?.paymentForField ?? '',
    mobileNumber: data?.pushSmsTo ?? data?.mobileNumber ?? '',
    email: data?.pushEmailTo ?? data?.email ?? '',
    invoice: data?.invoice ?? '',
    partialPayment: data?.partialPayment ?? false,
    expiry: data?.expiry ?? true,
    timer: data?.timer ?? '',
  }
}
